export const KEYS = {
  // TEST
  // RAZORPAY_KEY: "rzp_test_eF3IMlJkuPRNnp",


  // LIVE
  RAZORPAY_KEY: "rzp_live_vGolzReObPhK1x",

};
